import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { Col, Row } from "react-bootstrap";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { FixedAssetsMovingDto } from "../../../../dtos/documents/FixedAssetsMoving/FixedAssetsMovingDto";
import { FixedAssetsMovingModel } from "../../../../models/Documents/FixedAssetsMovingModel/FixedAssetsMovingModel";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import FixedAssetsMovingsDetailSkeleton from "./FixedAssetsMovingsDetailSkeleton";
import { FixedAssetsMovingsDetailMain } from "./FixedAssetsMovingsDetailMain";
import { FixedAssetsMovingsDetailAssets } from "./FixedAssetsMovingsDetailAssets";
import { useTranslation } from "react-i18next";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { FixedAssetsMovingsDetailFooter } from "./FixedAssetsMovingsDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";
interface IProps {
  model: FixedAssetsMovingDto | null;
  modelUpdatedEvent: (newModel: FixedAssetsMovingDto) => void;
}

const FixedAssetsMovingsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<FixedAssetsMovingModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;

  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Moving");

  useEffect(() => {
    console.log(model);
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("comment", model.comment);
      setValue("baseDocumentAtId", model.baseDocumentAtId);
      setValue("warehouseId", model.warehouseId);
      setValue("companyId", model.companyId);
      setValue("fixedAssets", model.fixedAssets);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: FixedAssetsMovingModel) => {
    if (action === "save") {
      const newModel: FixedAssetsMovingDto = { ...model, ...data };
      await saveHandler(newModel, action);
    } else if (action === "post") {
      const newModel: FixedAssetsMovingDto = { ...model, ...data };
      await saveHandler(newModel, action);
      await postHandler(action);
    }
  };

  if (!model) {
    return (
      <>
        <FixedAssetsMovingsDetailSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.FixedAssetsMoving.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmit("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmit("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <FixedAssetsMovingsDetailMain />
        </NFTabContainer>
        <NFTabContainer index={1} currentIndex={tabIndex}>
          <FixedAssetsMovingsDetailAssets />
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={t("Comment")} required={false} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <FixedAssetsMovingsDetailFooter />
    </FormProvider>
  );
};

export default FixedAssetsMovingsDetail;
